<template>
	<div class="guidelines">
		<h1>{{ $t('guidelines.title') }}</h1>

		<!-- Donation -->
		<div class="donation">

		<h2>{{ $t('guidelines.title2')}}</h2>

		<ul>
			<li>{{ $t('guidelines.listItem9')}}</li>
			<li>{{ $t('guidelines.listItem10')}}</li>
			<li>{{ $t('guidelines.listItem11')}}</li>
			<li>{{ $t('guidelines.listItem12')}}</li>
		</ul>

		</div>

		<!-- Application -->
		<div class="application">

			<h2>{{ $t('guidelines.title')}}</h2>

			<p>{{ $t('guidelines.intro')}}</p>

			<ul>
				<li>{{ $t('guidelines.listItem1')}}</li>
				<li>{{ $t('guidelines.listItem2')}}</li>
				<li>{{ $t('guidelines.listItem3')}}</li>
				<li>{{ $t('guidelines.listItem4')}}
					<ul>
						<li>{{ $t('guidelines.listItem5')}}</li>
						<li>{{ $t('guidelines.listItem6')}}</li>
						<li>{{ $t('guidelines.listItem7')}}</li>
					</ul>
				</li>
				<li>{{ $t('guidelines.listItem8')}}</li>
			</ul>
		</div>

	</div>
</template>


<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>

export default {
	name: 'Guidelines',
	components: {},
	props: [],

	/* ------------------------------ */
	/* DATA */
	data() {
		return {

		}
	},

	/* ------------------------------ */
	/* LIFECYCLE HOOKS */
	/* note: do not use arrow functions here */
	beforeCreate: function() {
	},
	created: function() {
	},
	beforeMount: function() {
	},
	mounted: function() {
	},
	beforeDestroy: function() {
	},
	destroyed: function() {
	},

	/* ------------------------------ */
	/* METHODS ETC */
	methods: {
	},
	computed: {
	},
	watch: {}
}
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>

.guidelines {


	@include max-medium {
		margin-bottom: $margin-bottom-mobile;
	}

	@include min-large {
		margin-bottom: $margin-bottom-desktop;
	}

	@include maxWidthCenter();

	padding-left: $padding-mobile;
	padding-right: $padding-mobile;

	@include min-large {
		@include flex(space-between, flex-start);
		flex-wrap: wrap
	}

	li {
		margin-bottom: .25em;
	}


	h1 {
		margin-bottom: 20px;
		@include min-large {
			flex: 0 0 100%;
			margin-bottom: 40px;
		}
	}

	.donation,
	.application {

		@include min-large {
			flex: 0 50%;

			@include ie-11 {
				flex: 0 43%;
			}
		}

		h2  {
			margin-bottom: 20px;
		}

	}




		@include min-large {
			.donation {
				padding-right: 6%;
			}
			.application {
				padding-left: 6%;
				// border-left: 1px solid $green-2;
			}
		}

	.application {
		@include max-medium {
			margin-top: 40px;
		}
	}
}

</style>
